import { getVTDomains } from './api';

export const domainNamesList = {
  domainNames: ['WorkMethod', 'WorkPerformed', 'WorkType']
};

export const loadAllDomains = async () => {
  try {
    return await getVTDomains(domainNamesList);
  } catch (error) {
    throw error;
  }
};
